import * as React from "react";
const Instagram = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2M12 15.88c-2.14 0-3.88-1.74-3.88-3.88S9.86 8.12 12 8.12s3.88 1.74 3.88 3.88-1.74 3.88-3.88 3.88m5.92-9q-.075.18-.21.33-.15.135-.33.21a.995.995 0 0 1-1.09-.21q-.135-.15-.21-.33A1 1 0 0 1 16 6.5c0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.23-.23.58-.34.9-.27.07.01.13.03.19.06q.09.03.18.09c.05.03.1.08.15.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38"
            fill={props.color || "#8E8E8E"}
        />
    </svg>
);
export default Instagram;
